import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { N500 } from '@atlaskit/theme/colors';
import { overrideStyleFunction } from '../../common/styles';
import { CustomItem } from '../Item';

var Container = function Container(props) {
  return /*#__PURE__*/React.createElement("div", props);
};

var Footer = function Footer(props) {
  var cssFn = overrideStyleFunction(function () {
    return {
      userSelect: 'auto',
      display: 'block',
      textAlign: 'center',
      minHeight: '24px',
      alignItems: 'center',
      width: '100%',
      '[data-item-elem-before]': {
        marginRight: 0,
        marginBottom: '8px',
        display: 'inline-block'
      },
      '[data-item-title]': {
        textAlign: 'center',
        fontSize: 12
      },
      '[data-item-description]': {
        textAlign: 'center',
        display: 'inline-block',
        margin: '6px'
      },
      // Will look interactive if the `component` is anything other than a div.
      'div&:hover': {
        backgroundColor: 'transparent',
        cursor: 'default'
      },
      'div&:active': {
        backgroundColor: 'transparent',
        color: "var(--ds-text-mediumEmphasis, ".concat(N500, ")")
      }
    };
  }, props.cssFn);
  return /*#__PURE__*/React.createElement(CustomItem, _extends({}, props, {
    component: props.component || Container,
    cssFn: cssFn
  }));
};

export default Footer;